<template>
  <v-dialog v-model="dialog" width="300">
    <v-card>
      <v-card-title>Teclado numérico</v-card-title>
      <v-card-text>
        <v-text-field v-model="value" label="Número"></v-text-field>

        <v-row>
          <v-col v-for="key in keys" :key="key" cols="4" class="text-center">
            <v-btn large block @click="appendValue(key)">
              {{ key }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="
            dialog = false;
            value = '';
          "
          >Cancelar</v-btn
        >
        <v-btn color="primary" @click="confirmValue">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      value: "",
      keys: ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "⌫"],
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    appendValue(key) {
      if (key === "⌫") {
        this.value = this.value.slice(0, -1);
      } else {
        this.value += key;
      }
    },
    confirmValue() {
      this.$emit("input", this.value);
      this.dialog = false;
      this.value = "";
    },
  },
};
</script>
